"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _MobileView = _interopRequireDefault(require("../../elements/view/MobileView"));

var _DesktopTabletView = _interopRequireDefault(require("../../elements/view/DesktopTabletView"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NavBarHidden = _styledComponents["default"].nav.attrs(function () {
  return {
    className: "navbar fixed-top navbar-expand-xl navbar-light bg-faded align-items-start justify-content-start",
    id: "best-navbar"
  };
}).withConfig({
  displayName: "NavigationVertical__NavBarHidden",
  componentId: "sc-1xvl1ou-0"
})(["&&&{padding:0;}"]);

var NavBarStyled = _styledComponents["default"].nav.attrs(function () {
  return {
    className: "navbar fixed-top navbar-expand-lg navbar-light bg-faded align-items-start justify-content-start",
    id: "best-navbar"
  };
}).withConfig({
  displayName: "NavigationVertical__NavBarStyled",
  componentId: "sc-1xvl1ou-1"
})(["&&&{width:68px;height:100vh;background-color:", ";z-index:1050;margin-top:59px;padding:10px 0 5px 0;box-shadow:2px 0 6px 0 rgba(0,0,0,0.1);border-top:1px solid #041e42;border-bottom:1px solid #041e42;}"], function (props) {
  return props.theme["mlb-blue"];
});

var NavigationVertical = function NavigationVertical(_ref) {
  var children = _ref.children,
      loggedIn = _ref.loggedIn,
      isLoginTab = _ref.isLoginTab;
  return _react["default"].createElement("div", null, loggedIn && _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_MobileView["default"], null, _react["default"].createElement(NavBarHidden, null, loggedIn ? children : null)), _react["default"].createElement(_DesktopTabletView["default"], null, _react["default"].createElement(NavBarStyled, {
    loggedIn: loggedIn,
    envIndicator: !isLoginTab,
    paddMobile: loggedIn
  }, loggedIn ? children : null))));
};

NavigationVertical.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  loggedIn: _propTypes["default"].bool.isRequired,
  isLoginTab: _propTypes["default"].bool
};
NavigationVertical.defaultProps = {
  displayName: "navigation-vertical",
  isProd: false,
  isLoginTab: false
};
var _default = NavigationVertical;
exports["default"] = _default;